import React from "react";
import InvoiceDetail from "./InvoiceDetail";

const InvoiceDetailPage: React.FC = () => {
  return <InvoiceDetail />;
};

export default InvoiceDetailPage;
